<template>
  <b-sidebar
    :id="`sidebar_guide_${id}`"
    v-model="visible"
    class="guide-body"
    right
    no-header-close
    z-index="50"
    backdrop
  >
    <div v-if="!sessionBooked" class="container">
      <div class="bar-header">
        <span></span>
        <div class="title d-flex justify-content-center align-items-center">
          <img
            src="/resources/images/logo/journeybinder_logo.png"
            alt="JB Logo"
            width="30"
            height="30"
          />
          <h5>Book Session</h5>
        </div>
        <div class="backSvg" @click="closeMe">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2929 6.29289C11.9024 6.68342 11.9024 7.31658 12.2929 7.70711L16.5858 12L12.2929 16.2929C11.9024 16.6834 11.9024 17.3166 12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L13.7071 6.29289C13.3166 5.90237 12.6834 5.90237 12.2929 6.29289Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 6.29289C4.90237 6.68342 4.90237 7.31658 5.29289 7.70711L9.58579 12L5.29289 16.2929C4.90237 16.6834 4.90237 17.3166 5.29289 17.7071C5.68342 18.0976 6.31658 18.0976 6.70711 17.7071L11.7071 12.7071C12.0976 12.3166 12.0976 11.6834 11.7071 11.2929L6.70711 6.29289C6.31658 5.90237 5.68342 5.90237 5.29289 6.29289Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      <hr />
      <div class="content">
        <div class="user">
          <div class="user-profile">
            <img
              v-if="guide.user && guide.user.imgURL"
              :src="guide.user.imgURL"
              alt=""
            />
            <empty-avatar
              v-if="guide.user && !guide.user.imgURL"
              :firstname="guide.user.firstname || ''"
              :lastname="guide.user.lastname || ''"
            />
          </div>
          <div
            v-if="guide.user && guide.user.firstname"
            class="text-center mt-2 pb-2"
          >
            <h5>{{ session.title }} with {{ guide.user.firstname }}</h5>

            <a href="https://my.journeybinder.com/sessions"
              >https://my.journeybinder.com/sessions</a
            >
          </div>
        </div>
        <div class="session-info">
          <span> {{ session.duration }} minutes </span>
          <span> ${{ session.price }} </span>
        </div>
        <div class="selector">
          <div class="header">
            <div v-if="!date.value">Select a day</div>
            <span v-if="date.value">{{ date.context.selectedFormatted }}</span>
            <span
              v-if="date.value"
              class="action"
              @click="showCalender = !showCalender"
              >EDIT</span
            >
          </div>
          <b-collapse
            id="collapse-calender"
            v-model="showCalender"
            class="mt-2"
          >
            <b-calendar
              block
              locale="en"
              hide-header
              :min="new Date().toISOString().slice(0, 10)"
              @context="onContext"
              @input="handleSetDay"
            >
            </b-calendar>
          </b-collapse>
        </div>
        <div v-if="date.value" class="selector">
          <div class="header">
            <div v-if="!time">Select a time</div>
            <span v-if="time">{{ time }}</span>
            <span v-if="time" class="action" @click="showTimes = !showTimes"
              >EDIT</span
            >
          </div>
          <b-collapse id="collapse-times" v-model="showTimes" class="mt-2">
            <div v-if="availbleTimes.length == 0">
              Sorry, Guide is not available on this date.
            </div>
            <div
              v-for="(time, index) in availbleTimes"
              :key="index"
              class="times"
            >
              <span @click="handleSetTime(time)"> {{ time }}</span>
            </div>
          </b-collapse>
        </div>
        <div v-show="date && time" class="selector">
          <div class="header">
            <div v-if="!cardNumber">Enter Card Details</div>
            <span v-if="cardNumber">{{ cardNumber }}</span>
            <span
              v-if="cardNumber"
              class="action"
              @click="showCheckout = !showCheckout"
              >EDIT</span
            >
          </div>
          <b-collapse
            id="collapse-checkout"
            v-model="showCheckout"
            class="mt-2"
          >
            <div class="card-element" id="card-element"></div>
            <div class="card-errors" id="card-errors" role="alert"></div>
            <!-- <b-form-input
            class="card-input"
            v-model="cardNumber"
            placeholder="Card Number"
          ></b-form-input>
          <div class="d-flex justify-space-between">
            <b-form-input
              class="card-input exp"
              v-model="cardExpiry"
              placeholder="EXP"
            ></b-form-input>
            <b-form-input
              class="card-input ccv"
              v-model="cardCcv"
              placeholder="CCV"
            ></b-form-input>
          </div>
          <b-form-input
            class="card-input"
            v-model="zipCode"
            placeholder="ZIP Code"
          ></b-form-input> -->
            <span class="promo">Use Promo code?</span>
            <b-form-input
              class="card-input"
              v-model="promoCode"
              placeholder="PROMO CODE"
            ></b-form-input>
            <b-button
              @click="bookSession"
              class="book-btn"
              block
              variant="primary"
              ><span v-if="!processingPayment">Book</span>
              <b-spinner
                class="book-spinner"
                v-if="processingPayment"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </b-collapse>
        </div>
      </div>
    </div>
    <div v-if="sessionBooked" class="session-booked">
      <h2>Awesomeness!</h2>
      <h4>
        Your session is booked with {{ guide.user.firstname }}. You will receive
        an email for additional info.
      </h4>
      <img
        class="mt-5"
        src="/resources/images/successful.png"
        alt="Session Booked"
        height="150"
        width="150"
      />
      <b-button
        @click="closeBookedSession"
        class="close-btn"
        block
        variant="primary"
        >CLOSE</b-button
      >
    </div>
  </b-sidebar>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import cardPlan from "@/components/jab/cardPlan";
import firebase from "firebase";
import emptyAvatar from "@/components/jab/emptyAvatar";
var card;
export default {
  name: "Guide",
  components: {
    emptyAvatar
  },
  props: {
    guide: {
      required: true
    },
    session: {
      required: true
    },
    onVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      id: null,
      visible: false,
      userInfo: {},
      processed: false,
      guideDetails: {},
      showCalender: true,
      showTimes: false,
      showCheckout: false,
      stripe: null,
      cardNumber: "",
      cardExpiry: "",
      cardCcv: "",
      zipCode: "",
      promoCode: "",
      date: {
        value: "",
        context: {}
      },
      time: "",
      availabilty: [],
      availbleTimes: [],
      bookings: [],
      sessionBooked: false,
      processingPayment: false
    };
  },
  watch: {
    onVisible(n, o) {
      this.visible = !this.visible;
    },
    session(n, o) {
      this.resetForm();
    },
    guide(n, o) {
      this.getGuideAvailability();
      this.getGuideSessions();
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  methods: {
    getGuideAvailability() {
      this.availabilty = [];
      let duration = parseInt(this.session.duration);
      this.$store
        .dispatch("listings/getGuideAvailability", this.guide.user.userId)
        .then(res => {
          if (res.length > 0) {
            res.forEach(element => {
              let mins = parseInt(this.session.duration);
              do {
                if (
                  this.AddMinutesToDate(element.start_date.toDate(), mins) >
                  element.end_date.toDate()
                )
                  break;
                let date = element.start_date.toDate();
                let time = this.AddMinutesToDate(
                  element.start_date.toDate(),
                  mins - duration
                );
                let oneEntry = {
                  date: this.formatDate(date),
                  time: this.formatAMPM(time)
                };
                this.availabilty.push(oneEntry);
                mins = mins + duration;
              } while (
                this.AddMinutesToDate(element.start_date.toDate(), mins) <
                element.end_date.toDate()
              );
              console.log(this.availabilty);
            });
          }
        })
        .catch(e => {
          console.log("Error in Fetching Guide Availability.", e);
        });
    },
    getGuideSessions() {
      this.bookings = [];
      this.$store
        .dispatch("user/getListGuideSessions", this.guide.user.userId)
        .then(res => {
          if (res.length > 0) {
            res.forEach(element => {
              if (element._booked_at) {
                let oneEntry = {
                  date: this.formatDate(element._booked_at.toDate()),
                  time: this.formatAMPM(element._booked_at.toDate())
                };
                this.bookings.push(oneEntry);
              }
            });
          }
        })
        .catch(e => {
          console.log("Error in Fetching Guide Sessions.", e);
        });
    },
    AddMinutesToDate(date, minutes) {
      return new Date(date.setMinutes(date.getMinutes() + minutes));
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatAMPM(date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    addCardElement() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PK);
      var elements = this.stripe.elements();
      card = elements.create("card");
      card.mount("#card-element");
      card.on("change", ({ error }) => {
        const displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });
    },
    onContext(ctx) {
      this.date.context = ctx;
    },
    handleSetDay(value) {
      this.availbleTimes = [];
      this.date.value = value;
      this.time = "";
      this.showCalender = false;
      this.showTimes = true;
      for (var i = this.availabilty.length - 1; i >= 0; i--) {
        for (var j = 0; j < this.bookings.length; j++) {
          if (
            this.availabilty[i] &&
            this.availabilty[i].date === this.bookings[j].date &&
            this.availabilty[i].time === this.bookings[j].time
          ) {
            this.availabilty.splice(i, 1);
          }
        }
      }
      this.availabilty.forEach(item => {
        if (item.date == value) {
          this.availbleTimes.push(item.time);
        }
      });
    },
    handleSetTime(time) {
      this.time = time;
      this.showCalender = false;
      this.showTimes = false;
      this.showCheckout = true;
      this.addCardElement();
    },
    bookSession() {
      this.processingPayment = true;
      let func = firebase.functions().httpsCallable("createPaymentIntents");
      func()
        .then(response => {
          this.stripe
            .confirmCardPayment(response.data.client_secret, {
              payment_method: {
                card: card,
                billing_details: {
                  name: this.profile.firstname
                }
              }
            })
            .then(result => {
              this.processingPayment = false;
              if (result.error) {
                this.$store.dispatch("user/showNotification", {
                  title: "Something went wrong. Please try later.",
                  description: result.error.message,
                  variant: "danger"
                });
              } else {
                if (result.paymentIntent.status === "succeeded") {
                  this.sessionBooked = true;
                  this.saveBooking();
                }
              }
            })
            .catch(error => {
              this.processingPayment = false;
              this.$store.dispatch("user/showNotification", {
                title: "Something went wrong. Please check back later.",
                description: error.message,
                variant: "danger"
              });
            });
        })
        .catch(error => {
          this.processingPayment = false;
          this.$store.dispatch("user/showNotification", {
            title: "An error occured while booking your session.",
            description: error.message,
            variant: "danger"
          });
        });
    },
    saveBooking() {
      let dayTime = `${this.date.value} ${this.time}`;
      this.$store
        .dispatch("session/createSession", {
          _booked_at: new Date(dayTime),
          room_id: `${this.guide.user.userId}_${
            this.$store.getters["user/user"].uid
          }_${moment().unix()}`,
          guide: {
            user_id: this.guide.user.userId,
            firstname: this.guide.user.firstname,
            lastname: this.guide.user.lastname,
            email: this.guide.user.email,
            imgURL: this.guide.user.imgURL
          },
          user: {
            user_id: this.profile.userId,
            firstname: this.profile.firstname,
            lastname: this.profile.lastname,
            email: this.profile.email,
            imgURL: this.profile.imgURL ? this.profile.imgURL : null
          },
          plan: {
            id: this.session.id,
            price: this.session.price,
            title: this.session.title,
            summary: this.session.summary
          }
        })
        .then(() => {
          this.$store.dispatch("user/showNotification", {
            title: `'${this.session.title}' Session Booked`,
            description: "Awesome. You will receive an email.",
            variant: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    closeBookedSession() {
      this.sessionBooked = false;
      this.visible = false;
      this.$emit("session-booked");
    },
    resetForm() {
      this.date = {
        value: "",
        context: {}
      };
      this.time = "";
      this.promoCode = "";
      this.showCalender = true;
      this.availbleTimes = [];
      this.getGuideAvailability();
      this.getGuideSessions();
    },
    closeMe() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-body {
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  z-index: 99;
  background-color: #fff;
  position: relative;
  .container {
    position: relative;
    padding: 0;
    * {
      z-index: 99 !important;
    }
    .bar-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        img {
          margin-bottom: 8px;
          margin-right: 5px;
        }
        h5 {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
        }
      }
      .backSvg {
        margin-left: -20px;
        cursor: pointer;
        svg {
          margin-top: -12px;
          margin-right: 5px;
        }
      }
    }
    hr {
      margin-top: 3px;
      padding-left: 0;
      border: 1px solid #dddddd;
    }
    .content {
      padding: 18px;
      .user {
        .user-profile {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 82px;
            height: 82px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
        a {
          font-size: 14px;
          margin-top: 5px;
        }
      }
      .session-info {
        padding: 7px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        background: #dde2e9;
        color: var(--theme-color);
        font-size: 14px;
      }
      .selector {
        margin-top: 8px;
        .header {
          display: flex;
          justify-content: space-between;
          padding: 5px;
          span {
            font-size: 13px;
            color: var(--theme-color);
          }
          div {
            font-weight: bold;
          }
          .action {
            cursor: pointer;
          }
        }
        .times {
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            margin: 5px;
            border-radius: 5px;
            cursor: pointer;
            width: 100%;
            text-align: center;
            font-size: 14px;
            color: var(--theme-color);
            padding-top: 5px;
            padding-bottom: 5px;
            border: 1px solid var(--theme-color);
          }
          span:hover {
            background: var(--theme-color);
            color: white;
          }
        }
        .card-input {
          margin-top: 5px;
          margin-bottom: 10px;
          background: #dde2e9;
          border-radius: 4px;
          border-color: transparent;
        }
        .exp {
          margin-right: 8px;
        }
        .ccv {
          margin-left: 8px;
        }
        .promo {
          padding-left: 2px;
          font-size: 10px;
          font-weight: bold;
          color: var(--theme-color);
        }
        .book-btn {
          margin-top: 50px;
          border-radius: 50px;
          border-color: transparent;
          .book-spinner {
            width: 1.3rem;
            height: 1.3rem;
          }
        }
        .card-element {
          padding-top: 10px;
          padding-bottom: 10px;
          padding-left: 11px;
          padding-right: 11px;
          margin-top: 5px;
          margin-bottom: 5px;
          background: #dde2e9;
          border-radius: 4px;
          border-color: transparent;
        }
        .card-errors {
          font-size: 10px;
          color: red;
        }
      }
    }
  }

  .session-booked {
    text-align: center;
    padding: 35px;
    margin-top: 80px;
    h2 {
      font-weight: bold;
      color: var(--theme-color);
    }
    h4 {
      margin-top: 40px;
    }
    .close-btn {
      margin-top: 80px;
      border-radius: 50px;
    }
  }
}
/*}*/
button:hover,
a:hover {
  box-shadow: 0px 2px 6px 0px #cbcbcb;
  cursor: pointer;
}
.guide-body {
  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #222;
  }
}
</style>
